import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { faArrowDown91, faArrowUp91, faAsterisk, faCode, faKey, faTrashAlt, faWarning } from '@fortawesome/free-solid-svg-icons';
import { NzModalService } from 'ng-zorro-antd/modal';
import { WrapperWorkflowSectionDto, WrapperWorkflowElementDto, doTouchAllFields, doGetInvalidControlsList } from '../../workflow-utils';
import { FormBuilder } from '@angular/forms';
import { WorkflowFormElementComponent } from '../workflow-form-element/workflow-form-element.component';
import { NzSelectOptionInterface } from 'ng-zorro-antd/select';

@Component({
	selector: 'app-workflow-form-section',
	standalone: false,
	templateUrl: './workflow-form-section.component.html',
	styleUrl: './workflow-form-section.component.scss'
})
export class WorkflowFormSectionComponent {
	@Input() input!: WrapperWorkflowSectionDto;
	@Input() mode!: 'Workflow' | 'ProductWorkflow';
	@ViewChild('editPopup', { static: true }) editPopup!: TemplateRef<any>;
	faWarning = faWarning;
	faAsterisk = faAsterisk;
	faKey = faKey;
	faCode = faCode;
	faArrowDown = faArrowDown91;
	faArrowUp = faArrowUp91;
	faTrash = faTrashAlt;
	statusOptions: NzSelectOptionInterface[] = [];

	constructor(private fb: FormBuilder, private modalService: NzModalService,) {
	}
	ngOnInit(): void {
		console.log("Statuses:",this.input.parent.statuses)
	}
	doEdit() {
		this.statusOptions = this.input.parent.statuses.map(status => ({
			label: status._label ?? 'No Label',
			value: status.payload.id
		}));
		const modal = this.modalService.create({
			nzTitle: 'Section Editor',
			nzContent: this.editPopup,
			nzFooter: null
		});
	}
	doRemove() {
		const index = this.input.parent.sections.indexOf(this.input);
		WrapperWorkflowSectionDto.remove(this.input.parent!, index);
	}

	addElement() {
		const element = WrapperWorkflowElementDto.add(this.fb, this.input!);
		this.viewProperty(element);
	}
	removeElement(item: WrapperWorkflowElementDto) {
		const index = this.input.elements.indexOf(item);
		WrapperWorkflowElementDto.remove(this.input!, index);
	}

	viewProperty(item: WrapperWorkflowElementDto) {
		// if(this.isProductWorkflow){
		// 	return;
		// }
		const modal = this.modalService.create({
			nzTitle: 'Input Editor: <b>' + item._label + '</b>',
			nzContent: WorkflowFormElementComponent,
			nzWidth: '75%',
			nzFooter: null
		});
		modal.componentInstance!.input = item;
		modal.componentInstance!.mode = this.mode;

	}


	touchAllFields() {
		doTouchAllFields(this.input.formGroup);
	}
	getInvalidControlsList() {
		return doGetInvalidControlsList(this.input.formGroup);
	}
	get isProductWorkflow():boolean{
		return this.mode == 'ProductWorkflow';
	}
}
